
import { BillPaymentRequest, BillSettingsDto } from '@proxy/bills/models'
export interface BillsSettings extends BillSettingsDto {

}
export interface PaymentRequest extends BillPaymentRequest {
    
}
